export default __webpack_public_path__ + "static/media/office_5.2baa9921.jpeg";